import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  constructor(
    private router: Router,
    private appService: AppService
  ) { }

  ngOnInit() {
  }

  aboutPage(event: Event) {
    event.preventDefault();
    this.router.navigate(['/about']);
    this.appService.inAboutMode.next(true);
  }

}
